export default __webpack_public_path__ + "static/media/closet5-after1-1920w.cdd0b68e.png";